import moment from 'moment'

export const kFormatter = (num, fraction = 2) =>
  num > 999 ? `${(num / 1000).toFixed(fraction)}k` : num

export const title = (value, replacer = ' ') => {
  if (!value) return ''
  const str = value.toString()

  const arr = str.split(replacer)
  const capitalizedArray = []
  arr.forEach(word => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalizedArray.push(capitalized)
  })

  return capitalizedArray.join(' ')
}

export const avatarText = args => {
  if (!args) return ''
  const nameparts = args.split(' ')
  const firstName = nameparts[0] || 'A'
  const lastName = nameparts[1] || ''

  return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
}

/**
 * Format and return date in Humanize format
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = 'MMM DD, YYYY') => {
  if (!value) return value

  return moment(new Date(value)).utc().format(formatting)
}

export const formatDateLocal = (value, formatting = 'MMM DD, YYYY') => {
  if (!value) return value

  return moment(new Date(value)).format(formatting)
}
export const formatDateWithTime = value => {
  if (!value) return value

  return moment(new Date(value)).format('MM/DD/YY, h:mm A')
}

// export const formatDateForCalender = (
//   value,
//   formatting = 'YYYY-MM-DD',
// ) => {
//   if (!value) return value

//   return moment(new Date(value)).utc().format(formatting)
// }
export const accountFormatDateForCalender = (value, formatting = 'YYYY-MM-DD') => {
  if (!value) return null
  return moment.utc(value).isValid() ? moment.utc(value).format(formatting) : null
}

export const formatDateForCalender = (value, formatting = 'MM-DD-YYYY') => {
  if (!value) return value

  // Ensure value is a valid date, then format it
  return moment.utc(value).isValid() ? moment.utc(value).format(formatting) : null
}
export const formatDateDDMMYYYY = (value, formatting = 'DD-MM-YYYY') => {
  if (!value) return value

  // Ensure value is a valid date, then format it
  return moment(value).isValid() ? moment(value).format(formatting) : null
}
export const formatDateMMYYYY = (value, formatting = 'YYYY-MM-DD') => {
  if (!value) return value

  // Ensure value is a valid date, then format it
  return moment(value).isValid() ? moment(value).format(formatting) : null
}
export const formatDateUtcYYYYMMDD = (value, formatting = 'YYYY-MM-DD') => {
  if (!value) return value

  // Ensure value is a valid date, then format it
  return moment.utc(value).isValid() ? moment.utc(value).format(formatting) : null
}

export const isToday = dateString => {
  if (!dateString) return false

  return moment().utc().isSame(dateString, 'day')
}

export const isPastDate = dateString => {
  const inputDate = moment.utc(dateString, 'YYYY-MM-DD', true)
  // Check if the input date is valid
  if (!inputDate.isValid()) {
    return false
  }
  const today = moment.utc().startOf('day')

  // Check if input date is before today
  return inputDate.isBefore(today)
}

/**
 * Format and return date in US format
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const DateFormatUS = (
  value,
  formatting = { month: '2-digit', day: '2-digit', year: 'numeric' },
) => {
  if (!value) return value

  return moment(new Date(value)).utc().format('MMM DD, YYYY')

  // return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 * Format and return value in USD
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 */

export const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export const currencyFormat = (value, currency = 'USD') => {
  if (value === null || value === undefined) return null

  const formattedCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  })

  return formattedCurrency.format(value)
}

/**
 * Return short human friendly month representation of date
 * Can also convert date to only time if date is of today (Better UX)
 * @param {String} value date to format
 * @param {Boolean} toTimeForCurrentDay Shall convert to time if day is today/current
 */
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// Strip all the tags from markup and return plain text
export const filterTags = value => value.replace(/<\/?[^>]+(>|$)/g, '')

export const replaceCamelSpaces = text => {
  return text.split(/(?=[A-Z])/).join(' ')
}

export const getFileThumbnail = fileName => {
  if (!fileName) return require('@/assets/images/icons/file-icons/doc_icon.svg')
  const patternFileExtension = /\.([0-9a-z]+)(?:[#]|$)/i
  const fileExtension = fileName.match(patternFileExtension)
  let thumbnail = require('@/assets/images/icons/file-icons/doc.png')

  if (fileExtension) {
    switch (fileExtension[0]) {
      case '.pdf':
        thumbnail = require('@/assets/images/icons/file-icons/pdf_1.png')
        break
      case '.xls':
      case '.xlsx':
        thumbnail = require('@/assets/images/icons/file-icons/xls.png')
        break
      case '.doc':
      case '.docx':
        thumbnail = require('@/assets/images/icons/file-icons/doc.png')
        break
      case '.ppt':
        thumbnail = require('@/assets/images/icons/file-icons/ppt_icon.svg')
        break
      case '.png':
      case '.jpg':
      case '.jpeg':
      case '.gif':
      case '.svg':
      case '.webp':
        thumbnail = require('@/assets/images/icons/file-icons/image_icon.svg')
        break
      case '.js':
      case '.json':
        thumbnail = require('@/assets/images/icons/file-icons/js.png')
        break
      case '.txt':
        thumbnail = require('@/assets/images/icons/file-icons/txt.png')
        break
      case '.zip':
        thumbnail = require('@/assets/images/icons/file-icons/zip_icon.svg')
        break
      default:
        thumbnail = require('@/assets/images/icons/file-icons/doc.png')
    }
  }

  return thumbnail
}

export const getFileExtension = fileName => {
  const patternFileExtension = /\.([0-9a-z]+)(?:[#]|$)/i

  const ext = fileName.match(patternFileExtension)

  return ext || []
}

export const removeExtension = fileName => {
  const name = fileName.split('.').slice(0, -1).join('.')

  return name || fileName
}

export const bulkDateFormat = (item, keys) => {
  const formattedData = { ...item }
  keys.forEach(key => {
    if (item[key]) {
      const date = moment(new Date(item[key])).utc().format('YYYY-MM-DD')
      formattedData[key] = date
    }
  })

  return formattedData
}

export const dateFormatLocal = (
  value,
  formatting = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  },
) => {
  if (!value) return value

  return new Date(value).toLocaleDateString('en-US', formatting)
}

// export const timeFormatLocal = (args, timeZone = 'UTC') => {
//   return args
//     ? new Date(args).toLocaleTimeString('en-US', {
//         hour: 'numeric',
//         minute: 'numeric',
//         hour12: true,
//         timeZone: timeZone,
//       })
//     : '';
// };
export const timeFormatLocal = (postDate, postTime) => {
  if (!postDate || !postTime) return ''

  // Combine the date and time into an ISO string with UTC timezone
  const utcDateTimeString = `${postDate}T${postTime}Z`

  // Create a Date object, treating the input as UTC
  const utcDate = new Date(utcDateTimeString)

  // Convert and format the time in the local timezone
  return utcDate.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true, // 12-hour format (AM/PM)
  })
}

export const dateTimeFormatLocal = (
  value,
  formatting = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
) => {
  if (!value) return value

  return new Date(value).toLocaleDateString('en-US', formatting)
}

export const generateUniqueNumber = prefix => {
  const timestamp = new Date().getTime()

  return `${prefix}${timestamp}`
}

export const printDOMElement = elementId => {
  document.getElementsByTagName('body')[0].style.visibility = 'hidden'
  document.getElementById(elementId).classList.add('print-cnt')
  window.print()
  document.getElementsByTagName('body')[0].style.visibility = 'visible'
  setTimeout(() => {
    document.getElementById(elementId).classList.remove('print-cnt')
  }, 500)
}

// Apply sorting to nested objects
export const deepSortBySequence = (data, key = 'sequence') => {
  if (Array.isArray(data)) {
    return data.map(deepSortBySequence).sort((a, b) => (a[key] || 0) - (b[key] || 0))
  }
  if (typeof data === 'object' && data !== null) {
    for (const key in data) {
      data[key] = deepSortBySequence(data[key]) // Apply sorting to nested objects
    }
  }

  return data
}

export const convertSecondsToTime = seconds => {
  if (isNaN(seconds) || seconds === null || seconds === undefined) return '00:00'
  const minutes = Math.floor(seconds / 60)
  const secs = seconds % 60

  return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}

export const formatTimeHHMM = seconds => {
  const hrs = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)

  return [hrs.toString().padStart(2, '0'), mins.toString().padStart(2, '0')].join(':')
}

export const getCalendarDate = () => {
  return moment().format('YYYY-MM-DD')
}
export const secondsToHHMMSS = seconds => {
  if (isNaN(seconds) || seconds < 0) {
    return '00:00:00'
  }

  const hrs = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)

  const formattedHrs = hrs < 10 ? `0${hrs}` : `${hrs}`
  const formattedMins = mins < 10 ? `0${mins}` : `${mins}`
  const formattedSecs = secs < 10 ? `0${secs}` : `${secs}`

  return `${formattedHrs}:${formattedMins}:${formattedSecs}`
}

export const proxyHtml = html => {
  if (!html) return html

  const proxyBase = `${process.env.VUE_APP_ROOT_API}/workdrive/proxy?key=`

  return html.replace(/<img([^>]+)src="([^">]+)"([^>]*)>/g, (match, beforeSrc, src, afterSrc) => {
    // Skip if already proxied
    if (src.startsWith(proxyBase)) {
      return `<img${beforeSrc}src="${src}"${afterSrc} crossorigin="anonymous">`
    }
    const proxiedSrc = `${proxyBase}${encodeURIComponent(src)}`

    return `<img${beforeSrc}src="${proxiedSrc}"${afterSrc} crossorigin="anonymous">`
  })
}
